import './styles.scss';

export default {
    name: 'MessagingChooseMessagePage',

    computed: {
        subscription() {
            return this.$store.state.subscriptions.active_subscription;
        },

        type() {
            return this.$store.state.messaging.message_type;
        }
    },

    created() {
        this.$store.commit('setMenuDetails', { 
            title: 'Emergency Messages', 
            slug: 'messaging',
            back_url: '/action/emergency-messages/notification-types'
        });
    },

    methods: {
        update(type) {
            this.message = type;
            this.$store.commit('setMessageType', type);

            if (type !== 'new') {
                this.$router.push('/action/emergency-messages/available-messages');
            } else {
                this.$store.commit('setMessage', '');
                this.$router.push('/action/emergency-messages/compose-message');
            }
        },

        cancel() {
            this.$ionic.alertController.create({
                header: 'Are you sure you want to cancel?',
                message: 'This action cannot be undone.',
                buttons: [
                    {
                        text: 'Yes',
                        handler: () => {
                            this.$store.commit('resetMessage');
                            this.$router.push('/action');
                        },
                    },
                    {
                        text: 'No',
                        role: 'cancel'
                    }
                ],
            }).then(a => a.present());
        }
    }
};